import HeaderBar from "../../../components/header/headerBar";
import { SearchField } from "../../../components/textfield";
import { SearchFieldSelect } from "../../../components/textfield";
// import Select from "../../../components/select/select";
import MainButton from "../../../components/button/mainButton";
import { useHistory } from "react-router";
import "../../../assets/styles/admin/giftvoucher.scss";
import { Input, Modal, Row, Space, Table, Typography, Select } from "antd";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import axios from "axios";
import { numberWithCommas } from "../../../helpers/functions";
import moment from "moment";

const GiftVoucher = () => {
  const [dataVoucher, setDataVoucher] = useState([]);
  const [isDisable, setIsDisable] = useState<any>([]);
  const [dataSearch, setDataSearch] = useState<any>([]);

  const history = useHistory();
  const { confirm } = Modal;
  const dateFormat = "DD-MM-YYYY";
  const { Text } = Typography;

  const option = [
    { value: "branch1", name: "All" },
    { value: "branch2", name: "All" },
    { value: "branch3", name: "All" },
    { value: "branch4", name: "All" },
  ];

  const columns = [
    {
      title: "",
      dataIndex: "rowCount",
      width: "5%",
    },
    {
      title: "Code",
      dataIndex: "code",
      align: "center" as const,
      render: (text: any) => text,
    },
    {
      title: "GiftDetail",
      dataIndex: "detail",
      align: "center" as const,
      render: (text: any) => {
        return <Row>{text}</Row>;
      },
    },
    {
      title: "PriceCredit",
      dataIndex: "credit",
      align: "center" as const,
      render: (text: any) => numberWithCommas(text, 2),
    },
    {
      title: "DateStartDateEnd",
      dataIndex: "date",
      align: "center" as const,
      width: "1%",
      render: (text: any, record: any) => {
        return (
          <>
            {" "}
            {record?.startDate ? (
              <Text>
                {moment(record?.startDate.substring(0, 10)).format(dateFormat)}
              </Text>
            ) : (
              ""
            )}
            <br />
            {record?.endDate ? (
              <Text>
                {moment(record?.endDate.substring(0, 10)).format(dateFormat)}
              </Text>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      title: "Renew",
      dataIndex: "date",
      align: "center" as const,
      render: (text: any, record: any) => {
        return (
          <>
            {record?.renew ? (
              <Text>
                {moment(record?.renew.substring(0, 10)).format(dateFormat)}
              </Text>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      title: "Action",
      align: "center" as const,
      colspan: 2,
      width: "1%",
      render: (text: any, record: any) => {
        return (
          <Row justify="space-around">
            <Space size="large">
              {text?.giftVoucher === "gv" && (
                <div
                  onClick={() => {
                    console.log("text", text);
                    history.push(`/setting/service/giftvoucher/${text?._id}`);
                  }}
                >
                  <Icon
                    icon="el:pencil-alt"
                    color="#5baea9"
                    width="20"
                    height="20"
                  />
                </div>
              )}
              <Row justify="end" onClick={() => showDeleteConfirm(record)}>
                <Icon
                  icon="icomoon-free:bin"
                  width="20"
                  height="20"
                  color="#FF6760"
                />
              </Row>
            </Space>
          </Row>
        );
      },
    },
  ];

  function showDeleteConfirm(value: any) {
    confirm({
      title: "",
      content: (
        <>
          {/* {console.log("value", value)} */}

          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${value?.detail} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${value?.detail} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(value._id);
      },
      width: "fit-content",
    });
  }

  const deleteData = (id: any) => {
    axios.delete(`/gift-vouchers/${id}`).then(() => {
      setTimeout(() => getData(), 200);
    });
  };
  const getData = () => {
    axios.get(`/gift-vouchers?page=1&perPage=20`).then((res) => {
      const xData = res?.data?.data;
      console.log("xData", xData);
      if (xData) {
        const datas = xData.map((data: any, index: number) => ({
          ...data,
          rowCount: index + 1,
        }));
        // console.log("datas=>>>>>>>", datas);
        setDataVoucher(datas);
      }
    });
  };

  const getAPIs = async () => {
    getData();
  };
  const types = [
    { value: "code", label: "Code" },
    // { value: "name", label: "GiftDetail" },
  ];

  const searchData = (e: any) => {
    const dataSearchs = e;
    const setGet = dataSearch.typeSearch;
    console.log("value :===>", dataSearchs, "<======>", "select =>>>> ");

    axios
      .get(
        `/gift-vouchers?giftVoucher=gv%2Cgc%2Cge&${setGet}=${dataSearchs.e}
      `
      )
      .then((res) => {
        const xData = res?.data?.data;
        console.log("xData", xData);
        if (xData) {
          const datas = xData.map((data: any, index: number) => ({
            ...data,
            rowCount: index + 1,
          }));
          console.log("datas=>>>>>>>", datas);
          setDataVoucher(datas);
        }
      });
  };
  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar title="GIFT VOUCHER LIST" />
      <div style={{ padding: "10px 40px" }}>
        {/* <SearchField
          placeholder="Search for Gift Voucher Code/Name"
          color="#fff"
        /> */}
        <div
          className="input-search select-search"
          style={{ marginBottom: "0px" }}
        >
          <Select
            className="select-search"
            bordered={false}
            placeholder="Search for Name"
            suffixIcon={
              <Icon
                icon="ant-design:caret-down-filled"
                style={{ color: "#AEAEAE" }}
              />
            }
            onChange={(e) => {
              setDataSearch({ ...dataSearch, typeSearch: e });
              setIsDisable({ ...isDisable, isSearch: true });
            }}
            options={types}
          />
          <Input.Search
            bordered={false}
            disabled={isDisable?.isSearch ? false : true}
            onSearch={(e) => {
              searchData({ e });
            }}
          />
        </div>

        <div className="row selectWapper">
          <div className="sCoin">
            <div className="text-select-wapper ">
              {/* <Select title="BRANCH :" option={option} /> */}
            </div>
            <div className="text-select-wapper">
              {/* <Select title="STATUS :" option={option} /> */}
            </div>
          </div>
          <div className="btnCoin">
            <MainButton
              title="CREATE GIFTVOUCHER"
              onClick={() => {
                history.push(`giftvoucher/giftvouchercate`);
              }}
            >
              <Icon
                icon="ant-design:plus-outlined"
                width="1.2rem"
                height="1.2rem"
                style={{ color: "#FFFFFF" }}
              />
            </MainButton>
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table
            columns={columns}
            dataSource={dataVoucher}
            rowKey="_id"
            bordered
            scroll={{ x: 100 }}
            size="small"
          ></Table>
        </div>
      </div>
    </div>
  );
};
export default GiftVoucher;
